import { localScoreRepository } from "Repositories/Local/localScoreRepository";


type SaveScoresToRemote = (params: {
  pageantId: number;
  eventId: number;
  eventJudgeId: number;
  rows: any[];
}) => Promise<void>;

let isSyncing = false;

export const judgeScoreSyncService = {
  async syncPendingScores(params: {
    saveScoresToRemote: SaveScoresToRemote;
  }): Promise<void> {
    if (isSyncing) return;
    if (!navigator.onLine) return;

    isSyncing = true;

    try {
      const pendingGroups =
        await localScoreRepository.getPendingScoreGroups();

      for (const group of pendingGroups) {
        try {
          await params.saveScoresToRemote({
            pageantId: group.pageantId,
            eventId: group.eventId,
            eventJudgeId: group.eventJudgeId,
            rows: group.rows,
          });

          await localScoreRepository.markScoresSynced(group.recordIds);
        } catch (error) {
          await localScoreRepository.markScoresFailed(
            group.recordIds,
            error,
          );
        }
      }
    } finally {
      isSyncing = false;
    }
  },
};